import * as React from "react";

import i18next from "i18next";

import { Nav, StyledNavLink } from "./styles";

const ManageAdminNavItem = () => {
  return (
    <Nav.Item>
      <StyledNavLink to="/manage-admin-tenant-admin">
        {i18next.t("users")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default ManageAdminNavItem;
